import * as React from 'react';

import {Avatar} from '../../avatar/avatar';
import {Card} from '../../card/card';

import type {Participant} from '../types';

import styles from './timeline-banner-comment-card.module.css';

const SINGLE_LINE_COMMENT_HEIGHT = 24;

type Props = {
    avatar: Participant;
    content: React.ReactNode;
};

export function TimelineBannerCommentCard(props: Props) {
    const {avatar, content} = props;

    const commentContainerRef = React.useRef(undefined);
    const [isMultilineComment, setIsMultilineComment] = React.useState<boolean>(false);

    React.useLayoutEffect(() => {
        if (commentContainerRef && commentContainerRef.current) {
            // @ts-expect-error
            if (commentContainerRef.current.clientHeight > SINGLE_LINE_COMMENT_HEIGHT) {
                setIsMultilineComment(true);
            }
        }
    }, []);

    return (
        <Card hasBorder={true} hasShadow={true} fitHeight={true}>
            <div className={styles['content-container']}>
                <div className={styles['avatar-container']}>
                    <Avatar
                        size={20}
                        avatarUrl={avatar.avatarUrl}
                        type={avatar.type}
                        initials={avatar.initials || ''}
                        circular={true}
                        border={true}
                    />
                </div>
                <div
                    ref={(r) => {
                        // @ts-expect-error
                        commentContainerRef.current = r;
                    }}
                    className={
                        isMultilineComment
                            ? styles['comment-container--multiline']
                            : styles['comment-container']
                    }
                >
                    {content}
                </div>
            </div>
        </Card>
    );
}
